export class PostEmailDto {

    company: number;
    name: string;
    surname: string;
    secondSurname: string;
    email: string;
    phone: string;
    constructor() {}
}